export default __webpack_public_path__ + "static/media/logotype-maor.75982276.png";